import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import styled from 'styled-components';
import { spacing } from '../../theme';
class Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  usedForFilter;
  hint;
  requiredLabel?: boolean=true;
}
const CheckboxContainer = styled.div`
    margin-bottom: ${spacing.spacing7};
`;
interface State {


}
export class CheckboxComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
  }

  componentDidMount(): void {
    let field = this.props.field;

    FormValidationUtils.runJavascript(field);
  }

  onCheckboxChange = (e) => {
    const val = (e.target.checked) ? 'Y' : 'N';

    // let control = this.props.field;
    let field = this.props.field;
    field.Value = val;

    if (!e.target.checked && this.props.field.Optional !== 'Y') {
      e.target.setAttribute('aria-invalid', 'true');
      e.target.setAttribute('aria-describedby', 'text-input-odometer-example-error-text');
    } else {
      e.target.removeAttribute('aria-invalid');
      e.target.removeAttribute('aria-describedby');
    }
 
    FormValidationUtils.validateCheckbox(field);
    FormValidationUtils.runJavascript(field); 

    this.props.callbackElement(field.parent.parent.parent);

  }

  render() {
    let field = this.props.field;

    let editable = this.props.editable;
    let controlArray = [];
    let title = this.props.title;

    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    const requireLabel = this.props.isEng ? "(required)" : "(obligatoire)";
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    let hint;
    if (field.Hint) {
      hint = htmlToReactParser.parse(hintHtml);
    }

    if (editable) {
      controlArray.push(
        <CheckboxContainer>
          <LiveValidationErrMsg
            field={field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + field.LoadBindName + field.Id} />

          <div style={{ display: field.Visible ? 'block' : 'none' }}  key={'fd_Checkbox_' + field.Id + "_" + field.Sequence} title={field.TooltipENU}>
            <div className="ontario-checkboxes__item ontario-checkboxes__single-option">
              <input
                className={field.Valid? "ontario-checkboxes__input":"ontario-checkboxes__input ontario-checkboxes__error"}
                id={field.LoadBindName} 
                key={'fdIpt_checkboxes_' + field.Id}
                name="options" type="checkbox"
                aria-checked={field.Value}
                required={field.Optional !== 'Y'}
                checked={field.Value === 'Y'}
                aria-required={field.Optional !== 'Y'} 
                aria-invalid={!field.Valid}
                aria-describedby={!field.Valid ? 'text-input-odometer-example-error-text' : ''}
                onChange={this.onCheckboxChange}
              />

              <label className="ontario-checkboxes__label" htmlFor={field.LoadBindName} id={field.LoadBindName+"_label"}>
                {title} {this.props.requiredField && this.props.requiredLabel? 
                <span className="ontario-label__flag">
                  {this.props.field.parent.parent.parent.UseAsterisks == "Y" 
                  ? <span style={{ color: 'red' }}>*</span> 
                  : <span className='ontario-label__flag' style={{display:this.props.requiredLabel?"block":"none"}}>{requireLabel}</span>
                }
                </span> : null}
              </label>
              {hint && <p className="ontario-hint">{hint}</p>}
            </div>
          </div>
        </CheckboxContainer>
      );
    } else {
      controlArray.push(
        <div className='pdf-two-column'>
          <div>{field.ENUTitle}</div>
          <div>
            {field.Value == 'Y' ? "Yes" : "No"}
          </div>
        </div>
      )
    }

    return controlArray;
  }
}